<template>
    <div class="grid row posts-content">
        <div class="flex xs12 md12">
            <va-card>
                <div>
                    <va-card-content>
                        <a-breadcrumb>
                            <a-breadcrumb-item>
                                <router-link to="/admin/dashboard" tag="a"
                                    >Home /
                                </router-link>
                            </a-breadcrumb-item>
                            <a-breadcrumb-item>
                                <router-link
                                    to="/admin/forum/forumindex"
                                    tag="a"
                                    >社区主页 /
                                </router-link>
                            </a-breadcrumb-item>
                            <a-breadcrumb-item>
                                <router-link
                                    to="/admin/forum/postsPage/index"
                                    tag="a"
                                    >{{ dataList.SectionName }} /
                                </router-link>
                            </a-breadcrumb-item>
                            <a-breadcrumb-item> 帖子详情 </a-breadcrumb-item>
                        </a-breadcrumb>
                        <a-breadcrumb v-if="false">
                            <a-breadcrumb-item
                                v-for="(itm, idx) in routerList"
                                :key="idx"
                            >
                                <router-link
                                    v-if="itm.children.length > 0"
                                    :to="`${itm.path}/${itm.children[0].name}`"
                                    tag="a"
                                >
                                    {{ itm.children[0].meta.title }}
                                </router-link>
                                <span v-else>{{ itm.meta.title }}</span>
                            </a-breadcrumb-item>
                        </a-breadcrumb>
                        <div
                            class="ant-row ant-row-middle ant-row-space-between"
                        >
                            <div class="ant-row">
                                <img
                                    :src="
                                        dataList.HeadPic ||
                                        require('@/static/images/headDefault.jpg')
                                    "
                                    alt=""
                                    class="user-img"
                                />
                                <div class="user-msg">
                                    <div
                                        style="
                                            position: relative;
                                            padding-right: 16px;
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <h2 class="boutique-tit">
                                            {{ dataList.Title }}
                                        </h2>
                                        <div
                                            class="posts-tab boutique"
                                            v-if="
                                                dataList.IsTop != 0 &&
                                                dataList.IsTop != null
                                            "
                                        >
                                            顶
                                        </div>
                                        <div
                                            class="posts-tab stick"
                                            v-if="
                                                dataList.IsElite != 0 &&
                                                dataList.IsElite != null
                                            "
                                        >
                                            精
                                        </div>
                                        <div
                                            class="posts-tab official"
                                            v-if="
                                                dataList.IsSys != 0 &&
                                                dataList.IsSys != null
                                            "
                                        >
                                            官
                                        </div>
                                    </div>

                                    <div style="display: block">
                                        <span style="color: gray"
                                            >{{ dataList.alias }}
                                        </span>
                                        <span
                                            >发布于{{
                                                dataList.CreateTime
                                            }}</span
                                        >
                                        <span
                                            >&nbsp;·&nbsp;浏览:{{
                                                dataList.ViewCount
                                            }}
                                            回复:{{ dataList.ReplyCount }}</span
                                        >
                                    </div>
                                </div>
                            </div>
                            <div>
                                <a href="#a1">
                                    <va-button
                                        class="flex xs14"
                                        :rounded="false"
                                        text-color="#ffffff"
                                        style="border-radius: unset"
                                    >
                                        快速回复
                                    </va-button>
                                </a>
                            </div>
                        </div>
                    </va-card-content>
                </div>
            </va-card>
        </div>
        <!-- <va-inner-loading :loading="isLoading" style="width: 100%;"  color="primary"> -->
        <div class="flex xs12 md12">
            <va-card>
                <va-card-content class="popst-htmlcontent">
                    <div
                        id="editor-content-view"
                        class="editor-content-view"
                        v-html="dataList.Contents"
                        @click="replayImgShow($event)"
                    ></div>
                </va-card-content>
                <va-card-content
                    class="ant-row ant-row-space-between ant-row-middle"
                >
                    <div>
                        <div
                            v-for="(item, index) in tabsList"
                            :key="index"
                            class="content-tabs"
                        >
                            {{ item }}
                        </div>
                    </div>
                    <div>
                        <span
                            class="compile"
                            @click="delPosts"
                            style="margin-right: 10px"
                            v-if="
                                $store.state.isAdmin == 1 ||
                                dataList.Creator == $store.state.userID
                            "
                            >删除</span
                        >
                        <router-link
                            :to="{
                                path: '/admin/forum/articleCompile',
                                query: { searcharticle: dataList.ID },
                            }"
                            class="compile"
                            v-if="dataList.Creator == $store.state.userID"
                            >编辑
                        </router-link>
                    </div>
                </va-card-content>
                <va-card-content>
                    <a
                        class="compile-a"
                        style="text-align: left"
                        target="_blank"
                        :href="dataList.FilePath"
                        v-if="dataList.FileName && dataList.IsPlay != 1"
                    >
                        <va-icon
                            class="icon-left input-icon"
                            name="file_download"
                        />
                        {{ dataList.FileName }}</a
                    >
                    <div
                        class="compile"
                        v-if="dataList.IsPlay != '' && dataList.IsPlay == 1"
                    >
                        <!-- <va-icon class="icon-left input-icon" name="videocam"/>{{dataList.FileName}} -->
                        <video
                            preload="meta"
                            controls="controls"
                            controlslist="nodownload"
                            width="600"
                            :src="dataList.FilePath"
                        >
                            您的浏览器不支持 HTML5 video 标签。
                        </video>
                    </div>
                </va-card-content>
                <va-card-content class="ant-row ant-row-space-between">
                    <div>
                        <div
                            :class="
                                collectValue ? 'accollect-btn' : 'collect-btn'
                            "
                            @click="thumbStateClick(1)"
                            data-code="1"
                            style="margin-right: 20px"
                        >
                            <va-icon
                                class="icon-left input-icon"
                                v-model:value="collectValue"
                                name="star"
                            />
                            <span>收藏</span>
                        </div>
                        <div
                            :class="likeValue ? 'accollect-btn' : 'collect-btn'"
                            @click="thumbStateClick(2)"
                            data-code="2"
                        >
                            <va-icon
                                class="icon-left input-icon"
                                v-model:value="likeValue"
                                name="favorite"
                            />
                            <span>点赞</span>
                        </div>
                    </div>
                    <div class="ant-row ant-row-middle">
                        <div class="like-img">
                            <img
                                :src="
                                    item.HeadPic ||
                                    require('@/static/images/headDefault.jpg')
                                "
                                alt=""
                                class=""
                                v-for="(item, index) in thumbList"
                                :key="index"
                            />
                        </div>
                        <span>{{ thumbList.length }}人点赞</span>
                    </div>
                </va-card-content>
            </va-card>
        </div>
        <!-- </va-inner-loading> -->
        <div class="flex xs12 md12">
            <posts-msg :isReplyProps="dataList.IsForbidReply"></posts-msg>
        </div>
    </div>
</template>
<script>
import { computed, defineComponent, ref } from "vue";
import previewImg from "./components/previewImg.js";
import { VXETable } from "vxe-table";
import postsMsg from "./components/postsMsg.vue";
import Qs from "qs";

export default defineComponent({
    name: "postsContent",
    components: {
        postsMsg,
        // Viewer
    },
    data() {
        return {
            images: [
                "https://picsum.photos/200/200",
                "https://picsum.photos/300/200",
                "https://picsum.photos/250/200",
            ],
            isLoading: false,
            likeValue: false, //点赞
            thumbList: [],
            collectValue: false, //收藏
            dataList: [],
            replyValue: {},
            msgValue: false,
            msgContent: "",
            postsText: ``,
            tabsList: [],
            prevPage: "版块主页",
            isQA: false,
            isSearch: false,
            prevHref: "",
            routerList: [],
            sourceImageObjects: [
                {
                    src: "https://picsum.photos/200/200?random=3",
                    "data-source": "https://picsum.photos/800/800?random=3",
                },
                {
                    src: "https://picsum.photos/200/200?random=4",
                    "data-source": "https://picsum.photos/800/800?random=4",
                },
            ],
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            // 通过 `vm` 访问组件实例,将值传入fromPath
            vm.fromPath = from.path;
            vm.routerList = to.matched;
            console.log(vm.routerList);
            vm.prevHref = from.path;
        });
    },

    methods: {
        replayImgShow(e) {
            if (e.target.currentSrc != undefined) {
                previewImg.init(e.target.currentSrc);
            }
        },
        async delPosts() {
            const type = await VXETable.modal.confirm(
                "您确定要删除这条帖子吗？"
            );
            if (type == "cancel") {
                return false;
            }

            let params = {
                ArticleID: this.$route.query.searcharticle, //帖子ID
                UserID: this.$store.state.userID, //用户UID
            };
            this.$api.formsAPI
                .delForumArticle(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    VXETable.modal.message({
                        content: "删除成功！",
                        status: "success",
                    });
                    this.$router.push({ path: "/admin/forum/postsPage/index" });
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        thumbStateClick(paramCode) {
            if (paramCode == 1) {
                //1 收藏 2 点赞 3 查看
                this.collectValue = !this.collectValue;
                if (this.collectValue) {
                    this.addThumbsUpCollect(paramCode);
                    this.addUserCredit(4);
                } else {
                    this.delThumbsUpCollect(paramCode);
                    this.delUserCredit(4);
                }
            } else if (paramCode == 2) {
                this.likeValue = !this.likeValue;
                if (this.likeValue) {
                    this.addThumbsUpCollect(paramCode);
                    this.addUserCredit(3);
                } else {
                    this.delThumbsUpCollect(paramCode);
                    this.delUserCredit(3);
                }
            }
        },
        //增加积分，2 发布 3 点赞 4 收藏
        delUserCredit(paramCode) {
            let params = {
                ArticleID: this.$route.query.searcharticle, //帖子ID
                UserID: this.$store.state.userID, //用户UID
                Type: paramCode,
            };
            this.$api.formsAPI
                .delUserCredit(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    if (paramCode == 1) {
                        VXETable.modal.message({
                            content: "取消收藏成功！",
                            status: "success",
                        });
                    } else if (paramCode == 2) {
                        VXETable.modal.message({
                            content: "取消点赞成功！",
                            status: "success",
                        });
                    }
                    this.findData();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //增加积分，2 发布 3 点赞 4 收藏
        addUserCredit(paramCode) {
            let params = {
                ArticleID: this.$route.query.searcharticle, //帖子ID
                UserID: this.$store.state.userID, //用户UID
                Type: paramCode,
            };
            this.$api.formsAPI
                .addUserCredit(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    if (paramCode == 1) {
                        VXETable.modal.message({
                            content: "取消收藏成功！",
                            status: "success",
                        });
                    } else if (paramCode == 2) {
                        VXETable.modal.message({
                            content: "取消点赞成功！",
                            status: "success",
                        });
                    }
                    this.findData();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        delThumbsUpCollect(paramCode) {
            let params = {
                ID: 0, //传0或不传
                ArticleID: this.$route.query.searcharticle, //帖子ID
                UserID: this.$store.state.userID, //用户UID
                Type: paramCode, //1 收藏 2 点赞 3 查看
            };
            this.$api.formsAPI
                .delThumbsUpCollect(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    if (paramCode == 1) {
                        VXETable.modal.message({
                            content: "取消收藏成功！",
                            status: "success",
                        });
                    } else if (paramCode == 2) {
                        VXETable.modal.message({
                            content: "取消点赞成功！",
                            status: "success",
                        });
                    }
                    this.findData();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //添加积分
        addThumbsUpCollect(paramCode) {
            let params = {
                ID: 0, //传0或不传
                ArticleID: this.$route.query.searcharticle, //帖子ID
                UserID: this.$store.state.userID, //用户UID
                Type: paramCode, //1 收藏 2 点赞 3 查看delThumbsUpCollect
            };
            this.$api.formsAPI
                .addThumbsUpCollect(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    if (paramCode == 1) {
                        VXETable.modal.message({
                            content: "收藏成功！",
                            status: "success",
                        });
                    } else if (paramCode == 2) {
                        VXETable.modal.message({
                            content: "点赞成功！",
                            status: "success",
                        });
                    }
                    if (paramCode != 3) {
                        this.findData();
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //查询帖子详情
        findData(findParam) {
            this.isLoading = true;
            let params = {
                uid: this.$store.state.userID,
                ArticleId: this.$route.query.searcharticle,
            };
            this.$api.formsAPI
                .getArticleByUser(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    this.dataList = res.data.Data.article;
                    let splitList =
                        res.data.Data.article.LabelName != null
                            ? res.data.Data.article.LabelName.split(",")
                            : [];
                    splitList.pop(); //去掉最后一个逗号
                    this.tabsList = splitList;
                    this.likeValue = res.data.Data.thumbState != "0";
                    this.collectValue = res.data.Data.collectState != "0";
                    this.thumbList = res.data.Data.thumbList;
                    // let imgEdit = res.data.Data.article.Contents.match(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi)
                    // console.log(imgEdit)
                    this.isLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
    mounted() {
        this.$nextTick(function () {
            if (this.prevHref == "/admin/forum/searchPage") {
                //搜索页面
                this.prevPage = "搜索页面";
                // this.isQA = true;
                this.isSearch = true;
                let par = JSON.parse(this.$store.state.searchData);
                this.$store.commit("updateSearchData", JSON.stringify(par));
            }

            if (this.$route.query.searcharticle != undefined) {
                //是否有文章id
                this.findData();
                this.addThumbsUpCollect(3);
            }
        });
    },
});
</script>
<style src="./css/antd.css"></style>
<style>
video::-webkit-media-controls-enclosure {
    overflow: hidden;
}

video::-webkit-media-controls-panel {
    width: calc(100% + 30px);
}
</style>
<style scoped lang="scss">
.popst-htmlcontent {
    overflow: hidden;
}

.compile {
    color: #1890ff;
    text-decoration: none;
    background-color: transparent;
    outline: none;
    cursor: pointer;

    &-a {
        width: 100%;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        -o-text-overflow: ellipsis;
    }
}

.collect-btn,
.accollect-btn {
    //#ffd43a
    line-height: 40px;
    cursor: pointer;
    border: 1px solid rgb(204, 204, 204);
    display: inline-block;
    color: #999;
    width: 110px;
    border-radius: 3px;
    text-align: center;

    span {
        margin-left: 5px;
    }
}

.msg-hover {
    // margin-left: 6px;
    color: #bfbfbf;
    font-size: 22px !important;
    cursor: pointer;

    &:hover {
        color: #ffd43a;
    }
}

.msg-user {
    span:nth-child(1) {
        color: #52bc89;
        font-size: 14px;
    }

    span:nth-child(2) {
        margin: 0 5px;
    }

    span:nth-child(3) {
        color: #afafaf;
        font-size: 13px;
        margin-right: 6px;
    }

    span:nth-child(4) {
        color: #afafaf;
        font-size: 13px;
    }
}

.like-img img {
    width: 28px;
    height: 28px;
    display: inline-block;
    margin-right: 6px;
    border-radius: 100%;
}

.accollect-btn:hover,
.collect-btn:hover {
    background: rgba(0, 0, 0, 0.04);
}

::v-deep .collect-btn i,
::v-deep .accollect-btn i {
    font-size: 26px !important;
    margin-top: -4px;
}

.accollect-btn i,
.accollect-btn span {
    color: #ffd43a;
}

.collect-btn i,
.collect-btn span {
    color: #999999;
}

.content-tabs {
    display: inline-block;
    padding: 6px 10px;
    margin-right: 10px;
    margin-bottom: 10px;
    vertical-align: top;
    font-size: 14px;
    color: #333;
    background-color: #eef4fa;
    -webkit-border-radius: 1px;
    -moz-border-radius: 1px;
    border-radius: 1px;
}

.user-img {
    width: 46px;
    height: 46px;
    margin-right: 10px;
    border-radius: 100%;
}

.msg-user-img {
    img {
        width: 46px;
        height: 46px;
        margin-right: 10px;
        border-radius: 100%;
    }
}

.boutique-tit {
    margin-bottom: 0;
    align-items: end;
    display: inline-block;
    position: relative;
}

.posts-tab {
    display: flex;
    align-items: center;
    line-height: 12px;
    text-align: center;
    padding: 3px;
    border-radius: 4px;
    font-size: 12px;
    color: #ffffff;
    margin: 0 3px;
}

.official {
    background: #5b95f9;
}

.stick {
    background: #e63e3b;
}

.boutique {
    background: #fa8429;
}

.user-msg {
    margin-right: 20px;
    color: #262626;
    font-size: 20px;
    line-height: 24px;
    font-weight: 500;
    text-overflow: ellipsis;
    white-space: nowrap;

    span {
        color: #ccc;
        font-size: 13px;
    }
}
</style>
<style>
.editor-content-view {
    border: 0px solid #ccc;
    overflow: auto;
}

.editor-content-view p,
.editor-content-view li {
    white-space: pre-wrap; /* 保留空格 */
}
.editor-content-view p,
h1,
h2,
h3,
h4,
h5,
h6 {
    margin: 10px 0;
}

.editor-content-view blockquote {
    border-left: 8px solid hsl(203, 57%, 88%);
    padding: 10px 10px;
    margin: 10px 0;
    background-color: #f1f1f1;
}

.editor-content-view code {
    font-family: monospace;
    background-color: #eee;
    padding: 3px;
    border-radius: 3px;
}
.editor-content-view pre > code {
    display: block;
    padding: 10px;
}

.editor-content-view table {
    border-collapse: collapse;
}
.editor-content-view td,
.editor-content-view th {
    border: 1px solid #ccc;
    min-width: 50px;
    height: 20px;
}
.editor-content-view th {
    background-color: #f1f1f1;
}

.editor-content-view ul,
.editor-content-view ol {
    padding-left: 20px;
}

.editor-content-view input[type="checkbox"] {
    margin-right: 5px;
}
</style>
